import { ChangeDetectionStrategy, Component, Inject, InjectionToken } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

export const NOTIFICATION_DATA = new InjectionToken<NotificationData>('Notification data');

export interface NotificationData {
  translationKey: string;
  params: { [key: string]: string };
}

@Component({
  selector: 'ten-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, MatIconModule],
})
export class NotificationComponent {
  constructor(@Inject(NOTIFICATION_DATA) public data: NotificationData) {}
}
